export default __webpack_public_path__ + "static/media/rank003.85a2a1b5.png";